import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpHeaders
} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const req = request.clone({
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        api_token: `${localStorage.getItem('token')}`,
        "Content-Type": `application/json`
      })
    });

    // const req = request.clone({
    //   headers: new HttpHeaders({
    //     Authorization: `Bearer ${localStorage.getItem('token')}`,
    //     api_token: `${localStorage.getItem('token')}`,
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //     'Accept': 'application/json'
    //   })
    // });
    return next.handle(req);
  }
}
